module.exports = __webpack_public_path__ + "static/media/Poppins-Regular.dd1aed50.ttf";